import { gql } from '@apollo/client';

export const SUBMIT_BID = gql`
  mutation SubmitBid($input: SubmitBidInput!) {
    submitBid(input: $input) {
      id
    }
  }
`;
